export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1])); // decode payload
    const expiry = payload.exp; // expiry time in seconds
    if (!expiry) return true;

    return (expiry * 1000) < Date.now(); // compare expiry to current time
  } catch (e) {
    return true; // If decoding fails, treat as expired
  }
}
